/**
 * Widget style types for different presentation modes
 */
export enum WidgetStyle {
    FLOATING_CARD = 'floating-card',      // Popup card that floats over content
    BANNER = 'banner',                    // Banner at top/bottom of page
    HORIZONTAL_CARD_LIST = 'horizontal-card-list', // Horizontal list of cards
    VERTICAL_CARD_LIST = 'vertical-card-list', // Vertical list of cards
    SLIDE_LIST = 'slide-list', // Slide show list of cards
    VERTICAL_ITEM_LIST = 'vertical-item-list', // List of items
}

/**
 * Position options for widgets
 */
export enum WidgetPosition {
    TOP_LEFT = 'top-left',
    TOP_CENTER = 'top-center',
    TOP_RIGHT = 'top-right',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_CENTER = 'bottom-center',
    BOTTOM_RIGHT = 'bottom-right',
    LEFT_CENTER = 'left-center',
    RIGHT_CENTER = 'right-center'
}
/**
 * Base interface for all widget implementations
 */
export interface IWidget {
    render(): HTMLElement;
    show(): void;
    hide(): void;
    toggle(): void;
    destroy(): void;
    isVisible(): boolean;
    updateData(data: any): void;
}

/**
 * Widget dimensions configuration
 */
export interface WidgetDimensions {
    width?: string;
    height?: string;
    maxWidth?: string;
    maxHeight?: string;
    minWidth?: string;
    minHeight?: string;
}

/**
 * Configuration for widget display
 */
export interface WidgetConfig {
    style: WidgetStyle;
    position?: WidgetPosition;
    autoShow?: boolean;
    showDelay?: number;
    persistent?: boolean;
    zIndex?: number;
    dimensions?: WidgetDimensions;
}